import { ResolveFn } from '@angular/router';

/** Joins the matched wildcard URL segments into the path fed to `DynamicPage`. */
export const dynamicPagePathResolver: ResolveFn<string> = (route) =>
  route.url.map((segment) => segment.path).join('/');
